import React from 'react';
import { Helmet as HelmetBase } from 'react-helmet-async';
import { useAppSelector } from '../../../base/hooks';

interface Props {
    pageName: string;
}

export const Helmet = ({ pageName }: Props) => {
    const { title, description } = useAppSelector((state) => state.employerApp.config.seo);

    return (
        <HelmetBase>
            <title>{`${pageName} ${title}`}</title>
            <meta name='description' content={`${pageName} ${description}`} />
        </HelmetBase>
    );
};
